import React, { useState, useRef } from "react";
import MapOverlay, {
  getViewportPositionFromLonLat,
  getLonLatFromViewportPosition,
} from "../../../components/MapOverlay";

const LocationInfoOverlay = (props) => {
  const [markers, setMarkers] = useState([]);
  const markersRef = useRef(markers);

  const areaTop = {
    width: 20,
    height: 20,
    x: 20,
    y: -50,
  };

  const areaBottom = {
    width: 20,
    height: 20,
    x: 20,
    y: -30,
  };

  let objects = [];

  const drawInfoBox = (context, x, y, unavailables, availables) => {
    if (unavailables > 0) {
      // draw background
      context.rect(x, y, areaTop.width, 2 * areaTop.height);
      context.fillStyle = "#f5f5f5";
      context.shadowColor = "#666666";
      context.shadowBlur = 4; // performance!
      context.shadowOffsetX = 2;
      context.shadowOffsetY = 2;
      context.fill();

      // draw border
      context.shadowColor = "transparent";
      context.strokeStyle = "#bbbbbb";
      context.rect(x, y, areaTop.width, 2 * areaTop.height);
      context.stroke();

      // draw seperator
      context.beginPath();
      context.moveTo(x, y + areaTop.height);
      context.lineTo(x + areaTop.width, y + areaTop.height);
      context.stroke();

      // draw labels
      context.font = "13px 'Open Sans'";
      context.textAlign = "center";
      context.fillStyle = "#ee2222";
      context.fillText(unavailables, x + areaTop.width * 0.5 + 1, y + 14);
      context.fillStyle = "#22cc22";
      context.fillText(availables, x + areaTop.width * 0.5 + 1, y + areaTop.height + 14);
    } else {
      // draw background
      context.rect(x, y + areaTop.height, areaTop.width, areaTop.height);
      context.fillStyle = "#f5f5f5";
      context.shadowColor = "#666666";
      context.shadowBlur = 4; // performance!
      context.shadowOffsetX = 2;
      context.shadowOffsetY = 2;
      context.fill();

      // draw border
      context.shadowColor = "transparent";
      context.strokeStyle = "#bbbbbb";
      context.rect(x, y + areaTop.height, areaTop.width, areaTop.height);
      context.stroke();

      // draw label
      context.font = "13px 'Open Sans'";
      context.textAlign = "center";
      context.fillStyle = "#22cc22";
      context.fillText(availables, x + areaTop.width * 0.5 + 1, y + areaTop.height + 14);
    }
  };

  const renderCanvas = (context, viewport, mapping) => {
    console.log("markers in draw: ", markersRef.current);
    console.log("viewport: ", viewport);
    console.log("mapping: ", mapping);

    if (
      typeof context !== "undefined" &&
      context !== null &&
      typeof markersRef.current !== "undefined" &&
      markersRef.current !== null
    ) {
      var pos;

      context.translate(0.5, 0.5);
      drawInfoBox(context, 200, 100, 1, 22);
      drawInfoBox(context, 250, 100, 0, 21);

      for (var i = 0; i < markersRef.current.length; i++) {
        pos = getViewportPositionFromLonLat(
          viewport,
          mapping,
          markersRef.current[i].longitude,
          markersRef.current[i].latitude,
        );
        //console.log("POS: ",pos);

        if (pos.left > 0 && pos.left < viewport.width && pos.top > 0 && pos.top < viewport.height) {
          // generate object
          let topObj = {
            x: pos.left + areaTop.x,
            y: pos.top + areaTop.y,
            width: areaTop.width,
            height: areaTop.height,
          };
          let bottomObj = {
            x: pos.left + areaBottom.x,
            y: pos.top + areaBottom.y,
            width: areaBottom.width,
            height: areaBottom.height,
          };
          objects.push(topObj);
          objects.push(bottomObj);

          drawInfoBox(context, pos.left + areaTop.x, pos.top + areaTop.y, 2, 14);

          //context.rect(pos.left + areaTop.x,pos.top + areaTop.y,areaTop.width,areaTop.height);
          //context.rect(pos.left + areaBottom.x,pos.top + areaBottom.y,areaBottom.width,areaBottom.height);
        }
      }
    }
  };

  const contentTouched = (x, y) => {
    console.log("content touched: " + x + " " + y);

    // proof if there is an object at this position
    //getLonLatFromViewportPosition

    for (var i = 0; i < objects.length; i++) {
      if (
        x > objects[i].x &&
        x < objects[i].x + objects[i].width &&
        y > objects[i].y &&
        y < objects[i] + objects[i].height
      ) {
        // matching object
        return true;
      }
    }
    return false;
  };

  const updateMarkers = (markers) => {
    markersRef.current = markers;
    //setMarkers(markers);
  };

  if (props.markers.length != markers.length) updateMarkers(props.markers);

  return (
    <>
      <MapOverlay
        map={props.map}
        api={props.api}
        mapContainerId={props.mapContainerId}
        render={renderCanvas}
        contentTouched={contentTouched}
      />
    </>
  );
};

export default LocationInfoOverlay;
